export const DOUBLE_ELIMINATION_MIN_TEAM_MINIMUM_VALUE = 4.0;
